import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { AccordionClass } from "../../artwork-overview/accordions";
import { ACCORDION_TITLE_CLASS } from "@/lib/accordion-content";

interface DescriptionEpreuvesTirageAccordionProps {
  descriptionHtml: string;
  t: (key: string) => string;
}

function normalizeRichTextHtmlForPreview(html: string) {
  // TipTap editor can display empty lines with trailing breaks in the editor DOM.
  // Persisted HTML may contain empty <p> tags instead, which collapse visually in preview.
  return html.replace(/<p([^>]*)>\s*<\/p>/g, "<p$1><br></p>");
}

export function DescriptionEpreuvesTirageAccordion({
  descriptionHtml,
  t,
}: DescriptionEpreuvesTirageAccordionProps) {
  const trimmed = descriptionHtml?.trim() ?? "";
  if (!trimmed) return null;
  const normalizedDescriptionHtml = normalizeRichTextHtmlForPreview(trimmed);

  return (
    <AccordionItem value="description-epreuves-tirage">
      <AccordionTrigger className={ACCORDION_TITLE_CLASS}>
        {t("singleMultipleprintDescriptionTirageLabel")}
      </AccordionTrigger>
      <AccordionContent>
        <div
          dangerouslySetInnerHTML={{ __html: normalizedDescriptionHtml }}
          className={AccordionClass}
        />
      </AccordionContent>
    </AccordionItem>
  );
}
